import type { Breakpoints } from '../breakpoints.class';

/**
 * Removes every rule-generated breakpoint from the collection, leaving hand-placed ones alone.
 * @param breakpoints the collection to clear
 * @returns number of breakpoints removed
 */
export const deleteRuleManagedCfn = (breakpoints: Breakpoints): number => {
	const managed = breakpoints.children.filter((breakpoint) => breakpoint.ruleManaged);
	return managed.filter((breakpoint) => breakpoints.delete(breakpoint.id)).length;
};
